import { makeStyles } from '@material-ui/core'
import { Theme } from '@styles/theme/theme'

const useStyles = makeStyles((theme: Theme) => ({
  layout: {
    padding: 16,
    height: '100%',
    background: theme.palette.spBackground,
  },

  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },

  header: {
    padding: '0px 26px',
    '& > div:first-child': {
      '& hr': {
        background: theme.palette.grey[400],
        width: 1,
        height: 16,
        margin: '0 12px'
      },
      '& p': {
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: 14,
        lineHeight: '28px',
        color: theme.palette.grey[700],
      },
      '& img': {
        width: 117,
        [theme.breakpoints.up('sm')]: {
          width: 140
        }
      }
    },
    [theme.breakpoints.up('sm')]: {
      padding: '0px 0px 16px 16px'
    },
    '& svg': {
      overflow: 'visible',
    }
  },

  sendsparkRedirect: {
    display: 'flex',
    alignItems: 'center',
    '& button.MuiButton-text': {
      display: 'flex',
      alignItems: 'center',
      fontStyle: 'normal',
      fontWeight: 'bold',
      lineHeight: '24px',
      fontSize: 14,
      color: theme.palette.primary.main,
      marginRight: 24,
      textTransform: 'none',
      borderRadius: 8,
      '& svg': {
        marginLeft: 4
      }
    },
    '& button.MuiButton-outlined': {
      color: theme.palette.primary.main,
      border: `2px solid ${theme.palette.primary.main}`,
      borderRadius: 8,
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '24px',
      textTransform: 'none',
      padding: '12px 16px',
      '&:hover': {
        border: `2px solid ${theme.palette.primary.main}`
      }
    }
  },
  contentContainer: {
    height: '100%',
    overflow: 'hidden',
  },
  content: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
  },
  lastStepContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  social: {
    display: 'flex',
    alignItems: 'center',

    '& button': {
      padding: '6px!important',
      marginRight: 8,
      minWidth: 0,
      borderRadius: '50%',
      '& svg': {
        margin: '0!important'
      }
    }
  },

  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '16px 0',
    [theme.breakpoints.up('sm')]: {
      margin: '22px 0px 0px 0',
      padding: '0px 8px'
    },

    '& button': {
      padding: 0,
      marginRight: 8,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 14,
      fontStyle: 'normal',
      lineHeight: '24px',
      textTransform: 'none',
      color: theme.palette.grey[700],

      [theme.breakpoints.up('sm')]: {
        fontWeight: 700,
        color: theme.palette.common.black,
        '&:last-of-type': {
          marginRight: 0
        },
      }
    }
  },

  copyright: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& p': {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '15px',
      fontStyle: 'normal',
      color: theme.palette.grey[700]
    }
  },

  codeInput: {
    border: `1px solid ${theme.palette.grey[200]}`,
    padding: '10px 16px',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
    '& p': {
      fontWeight: 700,
      fontSize: 14,
      lineHeight: '24px',
      fontStyle: 'normal'
    },
    '& button': {
      padding: 0,
      minWidth: 0,
      borderRadius: 8
    }
  },

  redirectSendspark: {
    width: '100%',
    borderRadius: 8,
    padding: '12px 15px',
    fontWeight: 'bold',
    fontSize: 14,
    lineHeight: '16px',
    fontStyle: 'normal',
    marginBottom: 16
  },

  giftDescription: {
    fontWeight: 400,
    fontSize: '16px!important',
    lineHeight: '24px',
    textAlign: 'center',
    fontStyle: '24px',
    color: theme.palette.grey[700]
  },

  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& p': {
      fontSize: 18,
      lineHeight: '24px',
      fontWeight: 400,
      fontStyle: 'normal',
      color: theme.palette.grey[700],
      textAlign: 'center',
      marginBottom: 16
    },
    '& button': {
      fontSize: 18,
      fontWeight: 700,
      padding: '20px 24px',
      borderRadius: 8,
      marginBottom: 35
    }
  },
  btnBackground: {
    padding: 6,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '50%',
    marginRight: 8,

    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
    }
  },

  btnFooterRight: {
    display: 'flex',
    '& button': {
      minWidth: '0px',
      [theme.breakpoints.up('sm')]: {
        marginRight: 24
      }
    }
  },

  hamburguerButton: {
    padding: '8px',
    '& .MuiButton-label': {
      justifyContent: 'flex-start',
      gap: 8,
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  hamburguerSendsparkButton: {
    height: 64,
    '& .MuiButton-label': {
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '24px',
    },
    '&:not(last-child)': {
      marginTop: 16,
    }
  },

  logo: {
    alignSelf: 'center',
  },

  topDots: {
    position: 'absolute',
    left: -120,
    top: -190,
  },

  bottomDots: {
    position: 'absolute',
    left: '30%',
    top: '50%',
  }
}))

export default useStyles
